import { gql } from '@apollo/client'
import { Erc721Rockpool, RockpoolItem } from '../../../../types/RockpoolTypes'

export interface Erc721OpenSeaQueryVars {
  chainId: number
  collection: string
  tokenId: string
}

export interface Erc721OpenSeaQueryData {
  erc721OpenSea: {
    rockpoolItem?: RockpoolItem
    erc721?: Erc721Rockpool
  }
}

export const ERC721_OPENSEA_QUERY = gql`
  query erc721OpenSea($chainId: Int!, $collection: String!, $tokenId: String!) {
    erc721OpenSea(chainId: $chainId, collection: $collection, tokenId: $tokenId) {
      rockpoolItem {
        chainId
        amount
        buyersCount
        description
        fee
        fractions
        fractionsCount
        id
        listed
        isErc721Available
        lastBuyers {
          amount
          buyer
          fractionsCount
          id
          ownership
        }
        name
        paymentToken {
          decimals
          id
          name
          symbol
        }
        poolProgress
        priceMultiplier
        reservePrice
        seller
        sellerFeeAmount
        sellerNetAmount
        status
        symbol
        target {
          boxItemCount
          chainId
          tokenId
          collection {
            id
            name
            symbol
          }
          id
          metadata {
            animationType
            animation_url
            asset_contract {
              name
              schema_name
            }
            attributes {
              trait_type
              value
            }
            author
            description
            discord
            image
            imageFull
            instagram
            name
            owner
            social_media
            telegram
            totalSupply
            twitter
            web_site_url
          }
        }
        targetPrice
        timestamp
      }
      erc721 {
        boxItemCount
        chainId
        price
        url
        collection {
          id
          name
          symbol
        }
        tokenId
        metadata {
          animationType
          animation_url
          asset_contract {
            name
            schema_name
          }
          attributes {
            trait_type
            value
          }
          author
          description
          discord
          image
          imageFull
          instagram
          name
          owner
          social_media
          telegram
          totalSupply
          web_site_url
        }
      }
    }
  }
`
